"use client"
import type { DocumentNode } from "graphql";
import { informationMediaMicroArticleCardDataFragmentDoc, informationMediaMicroCardsGroup, Maybe, _IContent, informationMediaMicroArticleCard } from "@gql/graphql";
import { InformationMediaMicroCard } from "@nrldigitaltechnology/ui-community";
import { NewsCard } from "@nrldigitaltechnology/ui-community/dist/components/InformationMediaMicroCard/types";
import dayjs from "dayjs";


type InformationMediaMicroArticleCardDataProps = {
  title?: string;
  // Accept either a single item or an array so the component can be used
  // both inside a group (array) and standalone (single object).
  data:
    | Maybe<informationMediaMicroArticleCard>
    | Maybe<Maybe<informationMediaMicroArticleCard>[]>
    | undefined;
  inEditMode?: boolean;
};

// Extend the component type to include the static getDataFragment method
interface InformationMediaMicroArticleCardProps
  extends React.FC<InformationMediaMicroArticleCardDataProps> {
  getDataFragment: () => [string, DocumentNode];
}

const InformationMediaMicroArticleCards: InformationMediaMicroArticleCardProps = ({
  title,
  data,
  inEditMode = false,
}: InformationMediaMicroArticleCardDataProps) => {
  // Normalise data so we always work with an array
  const items = Array.isArray(data) ? data : data ? [data] : [];

  const articleCards: NewsCard[] =
    items?.map((item, index) => {
      const publishedDate =
        item?.publishedDate && dayjs(item.publishedDate).isValid()
          ? dayjs(item.publishedDate).format("MMMM D, YYYY")
          : "";

      return {
        id: index,
        title: item?.articleTopic || "",
        category: item?.title || "",
        type: "news",
        image: item?.cardBackground?.url?.default || "",
        date: publishedDate,
        cardCtaUrl: item?.catUrl?.default || "",
        onClickCard: (card) => {
          if (card?.cardCtaUrl) {
            window.open(card.cardCtaUrl, "_blank", "noopener,noreferrer");
          }
        },
      };
    }) || [];

  return (
    <div className="flex flex-wrap justify-start gap-4">
      <InformationMediaMicroCard title={articleCards?.length > 0 ? title : ""} cards={articleCards} />
    </div>
  );
};

InformationMediaMicroArticleCards.displayName = "Media Article Card";

InformationMediaMicroArticleCards.getDataFragment = () => [
  "InformationMediaCardDataProps",
  informationMediaMicroArticleCardDataFragmentDoc];

// Attach the data fragment to the component
InformationMediaMicroArticleCards.getDataFragment = (): [string, DocumentNode] => [
  "InformationMediaCardDataProps",
  informationMediaMicroArticleCardDataFragmentDoc,
];

export default InformationMediaMicroArticleCards;
